import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=54cdc180&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54cdc180')) {
      api.createRecord('54cdc180', component.options)
    } else {
      api.reload('54cdc180', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=54cdc180&", function () {
      api.rerender('54cdc180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card.vue"
export default component.exports